import type { GuestSaveEnvelope } from '../saves/types';
import { apiRequest, isBackendConfigured } from './api';

export async function syncGuestSave(save: GuestSaveEnvelope): Promise<boolean> {
  if (!isBackendConfigured()) return false;
  await apiRequest('/saves/merge', {
    method: 'POST',
    body: JSON.stringify({
      schemaVersion: save.schemaVersion,
      contentVersion: save.contentVersion,
      revision: save.revision,
      payload: save.payload,
    }),
  });
  return true;
}
